<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge"
          v-html="$t('b2b_self_test_fear_of_movement_question')"
        />
      </div>
      <ScoreSlider
        :label="getFearOfMovementLabel"
        :max-score="10"
        :max-text="$t('b2b_self_test_fear_of_movement_max')"
        :min-text="$t('b2b_self_test_fear_of_movement_min')"
        :score="getFearOfMovementValue"
        data-q-a="score-slider"
        @change="handleFearOfMovementChange"
        @tap="handleFearOfMovementChange"
      />
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import ScoreSlider from '@shared/components/ScoreSlider.vue'
import { computed } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'

const reevaluationsStore = useSelfTestReevaluationStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const fearOfMovement = computed(() => reevaluationsStore.fearOfMovement)

const getFearOfMovementValue = computed(() =>
  fearOfMovement.value === -1 ? 5 : fearOfMovement.value,
)

const getFearOfMovementLabel = computed(() =>
  fearOfMovement.value === -1 ? '' : `${fearOfMovement.value}`,
)

const isValid = computed(
  () => fearOfMovement.value >= 0 && fearOfMovement.value <= 10,
)

const handleFearOfMovementChange = ({ value }) => {
  reevaluationsStore.fearOfMovement = value
}
</script>
